import type { FCC } from '@rikstv/play-common/src/utils/types/typeUtils';

import styles from './ActionButton.module.css';

export const ButtonList: FCC = ({ children }) => <div className={styles.buttonList}>{children}</div>;
